import config from '@/config/config';

import Index from '@/pages/config/contact-type/index.vue';
import List from '@/pages/config/contact-type/list/list.vue';
import View from '@/pages/config/contact-type/view/view.vue';
import New from '@/pages/config/contact-type/new/new.vue';
import Edit from '@/pages/config/contact-type/edit/edit.vue';

const modulePermission = config.modules.contactType;

export default {
  path: '/contact-type',
  name: 'contact-type',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'contact-type-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'contact-type-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'contact-type-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'contact-type-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
